/* eslint-disable id-match, filenames/match-regex */
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { getLocationShortName } from '../../helpers/location';
import Footer from '../footer/Footer';
import Form404 from './Form404';

const Form404Block = ({ statusCode, isSecurePage }) => {
  const [location] = useSelector((state) => [state.locations.location]);
  const shortName = getLocationShortName(location);

  return (
    <>
      <Form404 statusCode={statusCode} />
      <Footer
        isSecurePage={isSecurePage}
        locationShortName={shortName}
        site={process.env.NEXT_PUBLIC_SITE || 'fivepm'}
      />
    </>
  );
};

Form404Block.propTypes = {
  isSecurePage: PropTypes.bool,
  statusCode: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

Form404Block.defaultProps = {
  isSecurePage: false,
  statusCode: '404',
};

export default Form404Block;
